import React from 'react';
import { motion } from 'framer-motion';
export function AvatarPains() {
  const pains = [{
    emoji: '😔',
    text: <>
          You search for pet amigurumi patterns but only find{' '}
          <span className="text-terracotta font-bold" data-id="element-1">generic toys</span> that
          look nothing like your pet.
        </>
  }, {
    emoji: '😤',
    text: <>
          You have tried to adapt patterns on your own, but the result{' '}
          <span className="text-terracotta font-bold" data-id="element-2">never looks like</span>{' '}
          your real pet.
        </>
  }, {
    emoji: '💔',
    text: <>
          You want to give a handmade gift that is truly special — not{' '}
          <span className="text-terracotta font-bold" data-id="element-3">
            "just another stuffed toy"
          </span>
          .
        </>
  }, {
    emoji: '😩',
    text: <>
          You feel{' '}
          <span className="text-terracotta font-bold" data-id="element-4">
            frustrated spending hours
          </span>{' '}
          crocheting something that does not turn out right and ends up
          forgotten in a drawer.
        </>
  }];
  return <section className="py-10 md:py-16 bg-linen" data-id="element-5">
      <div className="max-w-3xl mx-auto px-4" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-7">
          <p className="text-sm font-bold tracking-[0.2em] text-copper uppercase mb-4" data-id="element-8">
            Does this sound familiar?
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-9">
            We understand how you feel...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-10">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="etsy-card p-5 flex items-start gap-4" data-id="element-11">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-12">
                {pain.emoji}
              </span>
              <p className="text-gray-600 leading-relaxed" data-id="element-13">{pain.text}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-10 text-copper font-heading italic text-lg" data-id="element-14">
          If you said "yes" to at least one... keep reading 👇
        </motion.p>
      </div>
    </section>;
}